import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getTaskSchedule = async (token: string, year: number, month: number) => {
  const url = `${API_BASE}/api/management/task-schedule?year=${year}&month=${month}`;
  return await apiFetch<CalendarEvent[]>(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTasks = async (
  token: string,
  options: { hideGlobalLoader?: boolean } = {}
) => {
  return await apiFetch<Task[]>(`${API_BASE}/api/management/tasks`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    hideGlobalLoader: options.hideGlobalLoader,
  });
};

export const createTask = async (token: string, task: Omit<Task, "id">) => {
  return await apiFetch<Task>(`${API_BASE}/api/management/create-task`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(task),
  });
};

export const editTask = async (token: string, taskId: number, data: Partial<Task>) => {
  return await apiFetch<Task>(`${API_BASE}/api/management/tasks/${taskId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

export const deleteTaskById = async (token: string, taskId: number) => {
  return await apiFetch<Task>(`${API_BASE}/api/management/tasks/${taskId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTimeline = async (token: string) => {
  return await apiFetch<TimelineEntry[]>(`${API_BASE}/api/management/timeline`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTimerTimeline = async (token: string) => {
  return await apiFetch<TimelineEntry[]>(`${API_BASE}/api/management/timer-timeline`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTasksProgress = async (token: string) => {
  return await apiFetch<PlanProgress[]>(`${API_BASE}/api/management/progress`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export interface CalendarEvent {
  id: number;
  title: string;
  category: string;
  task_type: string;
  detail: string;
  memo: string;
  priority: number;
  status: number;
  pomodoro_count: number;
  do_comment: string;
  planned_start: string;
  deadline: string;
  estimated_duration: number;
  worktime: number;
  completion_rate: number;
  source: string;
  is_ai_created: boolean;
  ai_plans_id: number | null;
  className: string;
  description: string;
}

export interface CalendarCardEvent {
  id: number | string;
  title: string;
  start: string | Date;
  end?: string | Date;
  className?: string;
  allDay?: boolean;
}

export type Task = {
  id: number;
  title: string;
  category: string;
  task_type: string;
  detail: string;
  memo: string | null;
  priority: number;
  status: number;
  pomodoro_count: number;
  do_comment: string | null;
  planned_start: string;
  deadline: string;
  estimated_duration: number | null;
  worktime: number | null;
  completion_rate: number | null;
  is_ai_created: boolean;
  ai_plans_id: number | null;
};

export interface TimelineEntry {
  color: string;
  icon: string;
  title: string;
  dateTime: string;
  description: string;
  lastItem?: boolean;
}

export interface PlanProgress {
  id: number;
  title: string;
  completed: number;
  total: number;
}